import LEProjectIndex from './src/LEProjectIndex.vue'

// 单组件注册
LEProjectIndex.install = (Vue) => {
  Vue.component(LEProjectIndex.name, LEProjectIndex)
}

export default LEProjectIndex
